// Mount-only komponent som renderar EntityDetailsDialog mot active
// workflow_id + dialog-context-state. Bryts ut från IndexBody för att
// hålla huvud-render-functionen mindre.

import { useEffect } from 'react';
import { useEntityDetailsDialog } from '@/contexts/useEntityDetailsDialog';
import { EntityDetailsDialog } from '@/components/editor/dialogs/EntityDetailsDialog';

export function EntityDetailsDialogMount({ currentDocumentId }: { currentDocumentId: string | null }) {
  const ed = useEntityDetailsDialog();
  // Synca active workflow_id till context så hooks som useEntityDetailsIndex
  // (badges på blocks) kan läsa det utan prop-drilling.
  useEffect(() => {
    ed.setWorkflowId(currentDocumentId);
  }, [currentDocumentId, ed]);
  return (
    <EntityDetailsDialog
      open={ed.open}
      onOpenChange={(o) => { if (!o) ed.closeDetails(); }}
      workflowId={currentDocumentId}
      entityId={ed.entityId}
      entityType={ed.entityType}
      entityName={ed.entityName}
    />
  );
}
